import { IStore } from 'Models/Store';

export enum USER_ROLES {
	ADMIN = 'Admin',
	INSTITUTION_ADMIN = 'InstitutionAdmin',
	STUDENT_ADVISOR = 'StudentAdvisor',
	CURRICULUM_SUPPORT = 'CurriculumSupport',
	STUDENT = 'User',
}

export type UserModels = `${USER_ROLES}`;

export const hasAnyRole = (store: IStore, groups: UserModels[]) => {
	const { userGroups } = store;
	return groups.some(r => userGroups.map(ug => ug.name).includes(r));
};
